require('./catalog-view.component.scss');

class CatalogViewController {
  constructor() {

  }
}

export const CatalogViewComponent = {
  template  : require('./catalog-view.component.html'),
  bindings  : {
    model    : '<',
    filter   : '<',
    filterBar: '<',
  },
  controller: CatalogViewController,
};



// WEBPACK FOOTER //
// ./src/view/catalog/catalog-view.component.js